export default __webpack_public_path__ + "static/media/homepage_banner.eede4a23.png";